<div>
    <rask-header size="4" noPadding>Validering (showroom-validation)</rask-header>
    <p>
        Validering går att göra på flera sätt i rask och det finns olika utseenden
    </p>
    <rask-tabs parameterName="section" aid="showroom-validation-tabs" [useRoute]="false" layout="child">
        <rask-tab label="raskrule">
            <div>
                <div class="row">
                    <div class="col">
                        <b>raskRule</b> är en custom-egenskap som man kan sätta på en komponent<br/>
                        Fyll i exempelvis 10 i input-boxarna
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <rask-input-number label="Antal stockar" [raskRule]="validation.validationStockar"
                            [(ngModel)]="modelToTest.stockar"></rask-input-number>
                    </div>
                    <div class="col-3">
                        <rask-input-number label="Antal pappersark" [raskRule]="validation.validationPappersark"
                            [(ngModel)]="modelToTest.pappersark"></rask-input-number>
                    </div>
                </div>
            </div>
        </rask-tab>
        <rask-tab label="raskrule gruppering">
            <div>
                <div class="row">
                    <div class="col">
                        Gruppera fel/varningar på ett ställe.
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <rask-input label="Alternativ 1" [(ngModel)]="modelToTest.alternativ1" [raskRule]="validation.validationAlternativ1" ruleContainerId="alternativValidationGruppPanel"></rask-input>
                        <rask-input label="Alternativ 2" [(ngModel)]="modelToTest.alternativ2" [raskRule]="validation.validationAlternativ2" ruleContainerId="alternativValidationGruppPanel"></rask-input>
                        <rask-input label="Alternativ 3" [(ngModel)]="modelToTest.alternativ3" [raskRule]="validation.validationAlternativ3" ruleContainerId="alternativValidationGruppPanel"></rask-input>
                        <rask-input label="Alternativ 4" [(ngModel)]="modelToTest.alternativ4" [raskRule]="validation.validationAlternativ4" ruleContainerId="alternativValidationGruppPanel"></rask-input>
                    </div>
                </div>
                <div class="row">
                    <rask-validation-message-container id="alternativValidationGruppPanel">
                    </rask-validation-message-container>
                </div>
            </div>
        </rask-tab>
        <rask-tab label="rule">
            <div>
                <div class="row">
                    <div class="col">
                        <b>rule</b> är en custom-egenskap som man kan sätta på en komponent<br/>
                        Fyll i exempelvis 10 i input-boxarna
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <rask-input-number label="Antal stubbar" [rule]="validation.validationStubbar"
                            [(ngModel)]="modelToTest.stubbar"></rask-input-number>
                    </div>
                    <div class="col-3">
                        <rask-input-number label="Antal grenar" [rule]="validation.validationGrenar"
                            [(ngModel)]="modelToTest.grenar"></rask-input-number>
                    </div>
                </div>
            </div>
        </rask-tab>

        <rask-tab label="Övrigt/Special">
            <p>
                Alla andra är special och är inte specificerade på komponent eller direktivnivå. Det är mer verksamhetsberoende och blir special.<br/>
                Exempelvis:<br/>
                Att man sätter en "grön bock"-ikon bredvid en text om det är godkänt<br/>
                I virkesköp finns många ställen där ikoner tänds eller inte beroende på valideringen.
            </p>
        </rask-tab>
    </rask-tabs>
    <rask-header size="4" noPadding>Fristående validerings meddealande</rask-header>
    <p>
        rask-validation-message-row kan användas om man inte har någon komponent som text rask-input med stöd för
        validering.
    </p>
    <rask-validation-message-row message="Exempel på fristående validerings meddealande"
        type="error"></rask-validation-message-row>
</div>